import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils/cn";
import React from "react";

const ActionBarContext = React.createContext<(visible: boolean) => void>(() => {});

function useActionBarPadding() {
  const [visible, setVisible] = React.useState(false);
  return { visible, setVisible };
}

interface ActionBarProps {
  show?: boolean;
  className?: string;
  children: React.ReactNode;
}

function ActionBar({ show = true, className, children }: ActionBarProps) {
  const { state } = useSidebar();
  const setVisible = React.useContext(ActionBarContext);

  React.useEffect(() => {
    setVisible(show);
    return () => setVisible(false);
  }, [show, setVisible]);

  return (
    <div
      className={cn(
        "fixed bottom-0 right-0 z-30 border-t bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60",
        "transform transition-all duration-200 ease-out",
        show ? "translate-y-0" : "translate-y-full",
        className,
      )}
      style={{
        left: state === "collapsed"
          ? "var(--sidebar-width-icon)"
          : "var(--sidebar-width)",
      }}
    >
      <div className="flex justify-center py-3">
        {children}
      </div>
    </div>
  );
}

export { ActionBar, ActionBarContext, useActionBarPadding };
